import SystemSettings from "./system"
import { Consumer, Provider, SystemSettingsContext } from "./system.context"

export { Consumer, Provider, SystemSettingsContext }
export default SystemSettings
